<template>
    <div class="report-pin d-flex">

        <div v-if="alerts && alerts.length" class="me-2">
            <button class="btn btn-sm btn-warning text-danger" data-bs-toggle="modal" data-bs-target="#alerts-modal"><i class="fa-solid fa-triangle-exclamation"></i><span class="d-none d-lg-inline"> Reported</span></button>
        </div>

        <div class="dropdown">
            <button class="btn btn-sm dropdown-toggle opacity-75" :class="success ? 'btn-success text-light' : 'btn-outline-secondary'" type="button" id="report-pin-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                <span v-if="success"><i class="fa-regular fa-circle-check"></i> Thank You</span>
                <span v-else><i class="fa-solid fa-flag d-none d-sm-inline"></i> Report<span class="d-none d-sm-inline d-md-none d-lg-inline"> this pin</span></span>
            </button>
            <ul class="dropdown-menu" aria-labelledby="report-pin-dropdown">
                <li><a @click="reportType='duplicate'" class="dropdown-item text-danger" href.prevent="#" data-bs-toggle="modal" data-bs-target="#report-modal">Duplicate Pin</a></li>
                <li><a @click="reportType='watermark'" class="dropdown-item text-danger" href.prevent="#" data-bs-toggle="modal" data-bs-target="#report-modal">Photo Copyright</a></li>
                <li><a @click="reportType='quality'" class="dropdown-item text-danger" href.prevent="#" data-bs-toggle="modal" data-bs-target="#report-modal">Low Quality Photo</a></li>
                <li><a @click="reportType='incorrect'" class="dropdown-item text-danger" href.prevent="#" data-bs-toggle="modal" data-bs-target="#report-modal">Incorrect Data ...</a></li>
                <li><a @click="reportType='other'" class="dropdown-item text-danger" href.prevent="#" data-bs-toggle="modal" data-bs-target="#report-modal">Other Issue ...</a></li>
            </ul>
        </div>

        <!-- <a v-if="!letManage && myPinventory.length > 1" :href="url" class="btn btn-success">you own {{ myPinventory.length }}</a> -->
        <!-- <button v-if="letManage && myPinventory.length > 0" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#manageCollection">Manage {{ myPinventory.length }} Pin{{ myPinventory.length > 1 ? 's' : '' }}</button> -->
        
        <div class="modal fade" tabindex="-1" id="report-modal" role="dialog">
            <div class="modal-dialog modal-md">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title fw-bold text-danger">Report {{ typeTitle }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p v-if="reportType === 'duplicate'">
                            Please add the PIN ID of the duplicate pin? (required)
                            <input type="text" class="form-control mt-2" v-model="duplicatePin" placeholder="DUPLICATE PIN ID" />
                        </p>
                        <p v-else-if="reportType === 'watermark'">
                            The photo for this pin is watermarked or violates copyright?
                            <textarea class="form-control mt-2" rows="5" v-model="copyrightInfo" placeholder="Copyright violation details"></textarea>
                        </p>
                        <p v-else-if="reportType === 'quality'">
                            The photo for this pin is low quality and needs to be edited or replaced?
                        </p>
                        <p v-else-if="reportType === 'incorrect'">
                            Please describe the data issue with this pin.
                            <textarea class="form-control mt-2" rows="5" v-model="issueDescription" placeholder="Data Issue Description"></textarea>
                        </p>
                        <p v-else-if="reportType === 'other'">
                            Please describe the issue with this pin.
                            <textarea class="form-control mt-2" rows="5" v-model="issueDescription" placeholder="Issue Description"></textarea></p>
                    </div>
                    <div class="modal-footer d-flex justify-content-between">
                        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Close</button>
                        <button @click="submitReport" type="button" class="btn btn-success text-light" data-bs-dismiss="modal" :disabled="reportType === 'duplicate' && !duplicatePin"><i class="fa-solid fa-flag"></i> Submit Report</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" tabindex="-1" id="alerts-modal" role="dialog">
            <div class="modal-dialog modal-md">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title fw-bold text-danger">Reported Data Alerts</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row row-cols-1">
                            <div v-for="alert in alerts" :key="alert.id" class="col">
                                <div class="alert shadow py-2 small" :class="[alert.resolved_at ? 'alert-secondary' : 'alert-warning']" role="alert">
                                <template v-if="alert.is_duplicate">
                                    <h4 class="alert-heading small"><div class="fs-4">Duplicate Reported</div> by: {{ alert.users.join(', ') }}</h4>
                                    <div class="small">
                                        Duplicate of ID: 
                                    <template v-if="alert.duplicate_ids.length">
                                        <a v-for="duplicate in alert.duplicate_ids" :key="duplicate" :href="'/pins/' + duplicate" target="_blank" class="alert-link ms-2">{{ duplicate }}</a>
                                    </template>
                                    <template v-else>
                                        <span class="text-muted">NOT GIVEN</span>
                                    </template>
                                    </div>
                                    <a :href="'/admin/merge?merge=pins&item1=' + pin + '&item2=' + alert.duplicate_id" class="btn btn-sm btn-outline-dark mt-2"><i class="fa-regular fa-clone"></i> Merge</a>
                                </template>
                                <template v-else-if="alert.is_db_duplicate">
                                    <h4 class="alert-heading small"><div class="fs-4">Duplicate Reported</div> by: SYSTEM</h4>
                                    <div class="small">
                                        Duplicate PTDB or PP of PIN ID: 
                                        <a :href="'/pins/' + alert.duplicate_id" target="_blank" class="alert-link ms-2">{{ alert.duplicate_id }}</a>
                                    </div>
                                    <a :href="'/admin/merge?merge=pins&item1=' + pin + '&item2=' + alert.duplicate_id" class="btn btn-sm btn-outline-dark mt-2"><i class="fa-regular fa-clone"></i> Merge</a>
                                </template>
                                <template v-else-if="alert.is_watermark">
                                    <h4 class="alert-heading small">
                                        <div class="fs-4">Photo violates copyright</div> 
                                        by: {{ alert.user.username }}
                                    </h4>
                                    <div v-if="alert.issue" class="small">
                                        <strong>Copyright Info: </strong>{{ alert.issue }}
                                    </div>
                                </template>
                                <template v-else-if="alert.is_low_quality">
                                    <h4 class="alert-heading small">
                                        <div class="fs-4">Low Quality Photo</div> 
                                        by: {{ alert.user.username }}
                                    </h4>
                                    <div class="small">
                                        Low quality or uncropped photo needs to be edited or replaced.
                                    </div>
                                </template>
                                <template v-else>
                                    <h4 class="alert-heading small">
                                        <div v-if="alert.is_incorrect" class="fs-4">Incorrect Data Reported</div> 
                                        <div v-else class="fs-4">Other Issue Reported</div> 
                                        by: {{ alert.user.username }}
                                    </h4>
                                    <div class="small">
                                        <strong>Issue Details: </strong>{{ alert.issue }}
                                    </div>
                                </template>
                                    <div class="mt-3 d-flex justify-content-end">
                                        <button v-if="alert.resolved_at" @click="reopenAlert(alert)" class="btn btn-sm btn-outline-dark"><i class="fa-regular fa-rotate-exclamation"></i> Undo</button>
                                        <button v-else @click="resolveAlert(alert)" class="btn btn-sm btn-outline-success"><i class="fa-regular fa-square-check"></i> Mark Resolved</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer d-flex justify-content-between">
                        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Close</button>
                        <a href="/my/help" class="btn btn-link">Go To Data Index</a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "ReportPin",
        props: ['pin', 'reports'],
        data() {
            return {
                reportType: null,
                duplicatePin: null,
                issueDescription: null,
                copyrightInfo: null,
                success: false,
                alerts: [],
            }
        },
        mounted() {
            this.alerts = this.reports;
        },
        created() {
            //
        },
        computed: {
            typeTitle: function() {
                if (this.reportType === 'duplicate') {
                    return 'Duplicate Pin';
                } else if (this.reportType === 'watermark') {
                    return 'Photo Copyright';
                } else if (this.reportType === 'quality') {
                    return 'Low Quality Photo';
                } else if (this.reportType === 'incorrect') {
                    return 'Incorrect Data';
                } else if (this.reportType === 'other') {
                    return 'Other Issue';
                } else {
                    return 'Pin';
                }
            },
        },
        methods: {
            resolveAlert: function(alert) {
                alert.resolved_at = new Date().toISOString();
                axios.put('/my/help/report/' + alert.id, {'status': 'resolve'}).then(response => {
                    if (response.status === 200) {
                        // console.log(response.data);
                    } else {
                        //
                    }
                });
            },
            reopenAlert: function(alert) {
                alert.resolved_at = null;
                axios.put('/my/help/report/' + alert.id, {'status': 'reopen'}).then(response => {
                    if (response.status === 200) {
                        // console.log(response.data);
                    } else {
                        //
                    }
                });
            },
            submitReport: function() {
                if (this.reportType === 'duplicate') {
                    this.reportDuplicate();
                } else if (this.reportType === 'watermark') {
                    this.reportWatermark();
                } else if (this.reportType === 'quality') {
                    this.reportQuality();
                } else if (this.reportType === 'incorrect') {
                    this.reportIncorrect();
                } else if (this.reportType === 'other') {
                    this.reportOther();
                }
            },
            reportDuplicate: function() {
                let data = { pin: this.pin, type: this.reportType, duplicate: this.duplicatePin };

                axios.post('/my/help/report', data).then(response => {
                    if (response.status === 200) {
                        this.isSuccess();
                    } else {
                        //
                    }
                });
            },
            reportIncorrect: function() {
                let data = { pin: this.pin, type: this.reportType, issue: this.issueDescription };

                axios.post('/my/help/report', data).then(response => {
                    if (response.status === 200) {
                        this.isSuccess();
                    } else {
                        //
                    }
                });
            },
            reportWatermark: function() {
                let data = { pin: this.pin, type: this.reportType, info: this.copyrightInfo };

                axios.post('/my/help/report', data).then(response => {
                    if (response.status === 200) {
                        this.isSuccess();
                    } else {
                        //
                    }
                });
            },
            reportQuality: function() {
                let data = { pin: this.pin, type: this.reportType };

                axios.post('/my/help/report', data).then(response => {
                    if (response.status === 200) {
                        this.isSuccess();
                    } else {
                        //
                    }
                });
            },
            reportOther: function() {
                let data = { pin: this.pin, type: this.reportType, issue: this.issueDescription };

                axios.post('/my/help/report', data).then(response => {
                    if (response.status === 200) {
                        this.isSuccess();
                    } else {
                        //
                    }
                });
            },
            isSuccess: function() {
                this.success = true;
                this.reset();
                setTimeout(() => {
                    this.success = false;
                }, 5000);
            },
            reset: function() {
                this.reportType = null;
                this.duplicatePin = null;
                this.issueDescription = null;
                this.copyrightInfo = null;
            }
        }
    }
</script>